export const SpreadsheetImportErrorCodes = {
  DIFFERENT_STRUCTURE: 'DIFFERENT_STRUCTURE',
  FAILED_TO_PREPARE_SOURCE: 'FAILED_TO_PREPARE_SOURCE',
  FAILED_TO_PREPARE_STRUCTURE: 'FAILED_TO_PREPARE_STRUCTURE',
} as const;

export type SpreadsheetImportErrorCode = typeof SpreadsheetImportErrorCodes[keyof typeof SpreadsheetImportErrorCodes];

export const isSpreadsheetImportErrorCode = (code?: string): code is SpreadsheetImportErrorCode => {
  return Object.values(SpreadsheetImportErrorCodes).includes(code as SpreadsheetImportErrorCode);
};
